import { render, staticRenderFns } from "./exerciseReview.vue?vue&type=template&id=6d3efa6c&scoped=true"
import script from "./exerciseReview.vue?vue&type=script&lang=js"
export * from "./exerciseReview.vue?vue&type=script&lang=js"
import style0 from "./exerciseReview.vue?vue&type=style&index=0&id=6d3efa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3efa6c",
  null
  
)

export default component.exports